import { UserRoleDto } from './../_models/userRole.models';
import { UserDto } from './../_models/user.models';
import axios, { AxiosResponse } from 'axios';
import { UserDetailDto } from '../_models';
import {
    AssignUserFactoriesPayloadStructure,
    AssignUserRolePayloadStructure,
    CreateUserPayloadStructure, UserListFiltersStructure,
} from "../_models/app.models";

const getUserDetail = (username: string, authenticate: boolean = false): Promise<AxiosResponse<UserDetailDto>> => {
    return axios.get('/api/v1/users/'+ username, {params: {authenticate}});
}

const getUserList = (filters: UserListFiltersStructure): Promise<AxiosResponse<UserDto[]>> => {
    return axios.get('/api/v1/users', {
        params: filters
    });
}

const getUserRoleList = (userEmail: string): Promise<AxiosResponse<UserRoleDto[]>> => {
    return axios.get('/api/v1/roles', {params: {userEmail}});
}

const createUser = (payload: CreateUserPayloadStructure) => {
    return axios.put('/api/v1/users', payload);
}

const assignUserRole = (payload: AssignUserRolePayloadStructure) => {
    return axios.put('/api/v1/users/roles', payload);
}

const assignUserFactories = (payload: AssignUserFactoriesPayloadStructure) => {
    return axios.put('/api/v1/users/factories', payload);
}


export const userService = {
    getUserDetail,
    getUserList,
    getUserRoleList,
    createUser,
    assignUserRole,
    assignUserFactories
}
